import * as THREE from 'three'

export default scene => {
    var ambientLight = new THREE.AmbientLight( 0x63637A, 0.1 );
    scene.add( ambientLight );
    var pointLight = new THREE.PointLight( 0xffffff, 0.7 );
    pointLight.position.set( 50, 50, 50 );
    scene.add( pointLight );

    var pointLightBlue = new THREE.PointLight( 0x193C78, 0.5 );
    var pointLightOrange = new THREE.PointLight( 0xFF3401, 0.1 );
    pointLightBlue.position.set( -50, -50, -50 );
    pointLightOrange.position.set( 50, 50, 50 );
    scene.add( pointLightBlue );
    scene.add( pointLightOrange );

    const rad = 80;

    function update(time) {
        // const x = rad * Math.sin(time*0.2);
    }

    return {
        update
    }
}